import {
  ArrayInput,
  BooleanInput,
  Edit,
  NumberInput,
  SaveButton,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  Toolbar,
  required,
} from "react-admin";
import HighlightOff from '@mui/icons-material/HighlightOff';

export const DNSZoneEdit = () => (
  <Edit redirect="show" mutationMode="pessimistic">
    <SimpleForm
      toolbar={
        <Toolbar>
          <SaveButton alwaysEnable />
        </Toolbar>
      }
    >
      <TextInput source="name" />
      <ArrayInput source="records">
        <SimpleFormIterator inline fullWidth>
          <TextInput source="name" validate={required()} />
          <TextInput source="type" validate={required()} />
          <TextInput source="content" sx={{flexGrow: 1}} />
          <NumberInput
            source="ttl"
            label="TTL"
            step={1}
            validate={required()}
            defaultValue={3600}
          />
          <BooleanInput source="disabled" defaultValue={false} title="Disabled" label={false} options={{
            checkedIcon: <HighlightOff />,
            color: 'error',
          }} />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);

export default DNSZoneEdit;
